import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charCodeAt1yspne1d8erbm as charCodeAt,
  charSequenceSubSequence1iwpdba8s3jc7 as charSequenceSubSequence,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx,
  Char__toInt_impl_vasixdnyockrdnmht5 as Char__toInt_impl_vasixd,
  toString22rbkbhdb5cl2 as toString,
  Char__minus_impl_a2frrhux3psqasp3d9 as Char__minus_impl_a2frrh,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { numberToChar93r9buh19yek as numberToChar } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import {
  toNumber2e2hj9zugjwi2 as toNumber,
  fromInt2ii0rejb1w62w as fromInt,
  multiply2k9eolhnz1bjv as multiply,
  add2suhfggl4zvkk as add,
  subtract2orl8z9upxd9l as subtract,
  numberToLong2pakxeg38estk as numberToLong,
  negate13xrbakfwasjy as negate,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { JsonPath2hoqh4ysli693 as JsonPath } from './JsonPath.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { toString1pkumu07cwy4m as toString_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { last1vo29oleiqj36 as last } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { removeLast3759euu1xvfa3 as removeLast } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { lastIndexOf2d52xhix5ymjr as lastIndexOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { decodingExceptionOf3hhtsziu575yf as decodingExceptionOf } from './JsonExceptions.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { charArray2ujmm1qusno00 as charArray } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function appendEscape($this, lastPosition, current) {
  $this.j2x(lastPosition, current);
  return appendEsc($this, current + 1 | 0);
}
function decodedString($this, lastPosition, currentPosition) {
  $this.j2x(lastPosition, currentPosition);
  var result = $this.b2n_1.toString();
  $this.b2n_1.ug(0);
  return result;
}
function takePeeked($this) {
  // Inline function 'kotlin.also' call
  var this_0 = ensureNotNull($this.a2n_1);
  $this.a2n_1 = null;
  return this_0;
}
function wasUnquotedString($this) {
  return !(charSequenceGet($this.k2x(), $this.y2m_1 - 1 | 0) === _Char___init__impl__6a9atx(34));
}
function appendEsc($this, startPosition) {
  var currentPosition = startPosition;
  currentPosition = $this.l2x(currentPosition);
  if (currentPosition === -1) {
    $this.o2s('Expected escape sequence to continue, got EOF');
  }
  var tmp = $this.k2x();
  var _unary__edvuaz = currentPosition;
  currentPosition = _unary__edvuaz + 1 | 0;
  var currentChar = charSequenceGet(tmp, _unary__edvuaz);
  if (currentChar === _Char___init__impl__6a9atx(117)) {
    return appendHex($this, $this.k2x(), currentPosition);
  }
  // Inline function 'kotlin.code' call
  var tmp$ret$0 = Char__toInt_impl_vasixd(currentChar);
  var c = escapeToChar(tmp$ret$0);
  if (c === _Char___init__impl__6a9atx(0)) {
    $this.o2s("Invalid escaped char '" + toString(currentChar) + "'");
  }
  $this.b2n_1.o1(c);
  return currentPosition;
}
function appendHex($this, source, startPos) {
  if ((startPos + 4 | 0) >= charSequenceLength(source)) {
    $this.y2m_1 = startPos;
    $this.m2x();
    if (($this.y2m_1 + 4 | 0) >= charSequenceLength(source)) {
      $this.o2s('Unexpected EOF during unicode escape');
    }
    return appendHex($this, source, $this.y2m_1);
  }
  $this.b2n_1.o1(numberToChar((((fromHexChar($this, source, startPos) << 12) + (fromHexChar($this, source, startPos + 1 | 0) << 8) | 0) + (fromHexChar($this, source, startPos + 2 | 0) << 4) | 0) + fromHexChar($this, source, startPos + 3 | 0) | 0));
  return startPos + 4 | 0;
}
function fromHexChar($this, source, currentPosition) {
  var character = charSequenceGet(source, currentPosition);
  var tmp;
  if (_Char___init__impl__6a9atx(48) <= character ? character <= _Char___init__impl__6a9atx(57) : false) {
    // Inline function 'kotlin.code' call
    var tmp_0 = Char__toInt_impl_vasixd(character);
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(48);
    tmp = tmp_0 - Char__toInt_impl_vasixd(this_0) | 0;
  } else if (_Char___init__impl__6a9atx(97) <= character ? character <= _Char___init__impl__6a9atx(102) : false) {
    // Inline function 'kotlin.code' call
    var tmp_1 = Char__toInt_impl_vasixd(character);
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(97);
    tmp = (tmp_1 - Char__toInt_impl_vasixd(this_1) | 0) + 10 | 0;
  } else if (_Char___init__impl__6a9atx(65) <= character ? character <= _Char___init__impl__6a9atx(70) : false) {
    // Inline function 'kotlin.code' call
    var tmp_2 = Char__toInt_impl_vasixd(character);
    // Inline function 'kotlin.code' call
    var this_2 = _Char___init__impl__6a9atx(65);
    tmp = (tmp_2 - Char__toInt_impl_vasixd(this_2) | 0) + 10 | 0;
  } else {
    $this.o2s("Invalid toHexChar char '" + toString(character) + "' in unicode escape");
  }
  return tmp;
}
function consumeBoolean2($this, start) {
  var current = $this.l2x(start);
  if (current >= charSequenceLength($this.k2x()) || current === -1) {
    $this.o2s('EOF');
  }
  var tmp = $this.k2x();
  var _unary__edvuaz = current;
  current = _unary__edvuaz + 1 | 0;
  // Inline function 'kotlin.code' call
  var this_0 = charSequenceGet(tmp, _unary__edvuaz);
  var tmp0_subject = Char__toInt_impl_vasixd(this_0) | 32;
  var tmp_0;
  // Inline function 'kotlin.code' call
  var this_1 = _Char___init__impl__6a9atx(116);
  if (tmp0_subject === Char__toInt_impl_vasixd(this_1)) {
    consumeBooleanLiteral($this, 'rue', current);
    tmp_0 = true;
  } else {
    // Inline function 'kotlin.code' call
    var this_2 = _Char___init__impl__6a9atx(102);
    if (tmp0_subject === Char__toInt_impl_vasixd(this_2)) {
      consumeBooleanLiteral($this, 'alse', current);
      tmp_0 = false;
    } else {
      $this.o2s("Expected valid boolean literal prefix, but had '" + $this.x2t() + "'");
    }
  }
  return tmp_0;
}
function consumeBooleanLiteral($this, literalSuffix, current) {
  if ((charSequenceLength($this.k2x()) - current | 0) < literalSuffix.length) {
    $this.o2s('Unexpected end of boolean literal');
  }
  var inductionVariable = 0;
  var last = charSequenceLength(literalSuffix) - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var expected = charCodeAt(literalSuffix, i);
      var actual = charSequenceGet($this.k2x(), current + i | 0);
      // Inline function 'kotlin.code' call
      var tmp = Char__toInt_impl_vasixd(expected);
      // Inline function 'kotlin.code' call
      if (!(tmp === (Char__toInt_impl_vasixd(actual) | 32))) {
        $this.o2s("Expected valid boolean literal prefix, but had '" + $this.x2t() + "'");
      }
    }
     while (inductionVariable <= last);
  $this.y2m_1 = current + literalSuffix.length | 0;
}
function consumeNumericLiteral$calculateExponent(exponentAccumulator, isExponentPositive) {
  var tmp;
  switch (isExponentPositive) {
    case false:
      // Inline function 'kotlin.math.pow' call

      var x = -toNumber(exponentAccumulator);
      tmp = Math.pow(10.0, x);
      break;
    case true:
      // Inline function 'kotlin.math.pow' call

      var x_0 = toNumber(exponentAccumulator);
      tmp = Math.pow(10.0, x_0);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
var AbstractJsonLexerClass;
function AbstractJsonLexer() {
  if (AbstractJsonLexerClass === VOID) {
    class $ {
      constructor(configuration) {
        this.x2m_1 = configuration;
        this.y2m_1 = 0;
        this.z2m_1 = new (JsonPath())(this.x2m_1);
        this.a2n_1 = null;
        this.b2n_1 = StringBuilder().l1();
      }
      m2x() {
      }
      h2u() {
        var current = this.n2x();
        var source = this.k2x();
        if (current >= charSequenceLength(source) || current === -1)
          return false;
        if (charSequenceGet(source, current) === _Char___init__impl__6a9atx(44)) {
          this.y2m_1 = this.y2m_1 + 1 | 0;
          return true;
        }
        return false;
      }
      o2x(c) {
        return c === _Char___init__impl__6a9atx(125) || c === _Char___init__impl__6a9atx(93) || (c === _Char___init__impl__6a9atx(58) || c === _Char___init__impl__6a9atx(44)) ? false : true;
      }
      c2n() {
        var nextToken = this.z2t();
        if (!(nextToken === 10)) {
          this.o2s('Expected EOF after parsing, but had ' + toString(charSequenceGet(this.k2x(), this.y2m_1 - 1 | 0)) + ' instead');
        }
      }
      t2t(expected) {
        var token = this.z2t();
        if (!(token === expected)) {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.fail' call
          var expected_0 = tokenDescription(expected);
          var position = true && this.y2m_1 > 0 ? this.y2m_1 - 1 | 0 : this.y2m_1;
          var s = this.y2m_1 === charSequenceLength(this.k2x()) || position < 0 ? 'EOF' : toString(charSequenceGet(this.k2x(), position));
          var tmp$ret$1 = 'Expected ' + expected_0 + ", but had '" + s + "' instead";
          this.o2s(tmp$ret$1, position);
        }
        return token;
      }
      p2x(expected) {
        if (this.y2m_1 > 0 && expected === _Char___init__impl__6a9atx(34)) {
          var tmp$ret$0;
          $l$block: {
            // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.withPositionRollback' call
            var snapshot = this.y2m_1;
            try {
              this.y2m_1 = this.y2m_1 - 1 | 0;
              tmp$ret$0 = this.x2t();
              break $l$block;
            }finally {
              this.y2m_1 = snapshot;
            }
          }
          var inputLiteral = tmp$ret$0;
          if (inputLiteral === 'null') {
            this.n2s("Expected string literal but 'null' literal was found", this.y2m_1 - 1 | 0, "Use 'coerceInputValues = true' in 'Json {}' builder to coerce nulls if property has a default value.");
          }
        }
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.fail' call
        var expectedToken = charToTokenClass(expected);
        var expected_0 = tokenDescription(expectedToken);
        var position = true && this.y2m_1 > 0 ? this.y2m_1 - 1 | 0 : this.y2m_1;
        var s = this.y2m_1 === charSequenceLength(this.k2x()) || position < 0 ? 'EOF' : toString(charSequenceGet(this.k2x(), position));
        var tmp$ret$3 = 'Expected ' + expected_0 + ", but had '" + s + "' instead";
        this.o2s(tmp$ret$3, position);
      }
      u2t() {
        var source = this.k2x();
        var cpos = this.y2m_1;
        $l$loop_0: while (true) {
          cpos = this.l2x(cpos);
          if (cpos === -1)
            break $l$loop_0;
          var ch = charSequenceGet(source, cpos);
          if (ch === _Char___init__impl__6a9atx(32) || ch === _Char___init__impl__6a9atx(10) || ch === _Char___init__impl__6a9atx(13) || ch === _Char___init__impl__6a9atx(9)) {
            cpos = cpos + 1 | 0;
            continue $l$loop_0;
          }
          this.y2m_1 = cpos;
          return charToTokenClass(ch);
        }
        this.y2m_1 = cpos;
        return 10;
      }
      i2u(doConsume) {
        var current = this.n2x();
        current = this.l2x(current);
        var len = charSequenceLength(this.k2x()) - current | 0;
        if (len < 4 || current === -1)
          return false;
        var inductionVariable = 0;
        if (inductionVariable <= 3)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (!(charCodeAt('null', i) === charSequenceGet(this.k2x(), current + i | 0)))
              return false;
          }
           while (inductionVariable <= 3);
        if (len > 4 && charToTokenClass(charSequenceGet(this.k2x(), current + 4 | 0)) === 0)
          return false;
        if (doConsume) {
          this.y2m_1 = current + 4 | 0;
        }
        return true;
      }
      t2u(doConsume, $super) {
        doConsume = doConsume === VOID ? true : doConsume;
        return $super === VOID ? this.i2u(doConsume) : $super.i2u.call(this, doConsume);
      }
      j2u(isLenient) {
        var token = this.u2t();
        var tmp;
        if (isLenient) {
          if (!(token === 1) && !(token === 0))
            return null;
          tmp = this.x2t();
        } else {
          if (!(token === 1))
            return null;
          tmp = this.w2t();
        }
        var string = tmp;
        this.a2n_1 = string;
        return string;
      }
      q2x() {
        this.a2n_1 = null;
      }
      r2x(startPos, endPos) {
        // Inline function 'kotlin.text.substring' call
        var this_0 = this.k2x();
        return toString_0(charSequenceSubSequence(this_0, startPos, endPos));
      }
      w2t() {
        if (!(this.a2n_1 == null)) {
          return takePeeked(this);
        }
        return this.m2u();
      }
      consumeString2(source, startPosition, current) {
        var currentPosition = current;
        var lastPosition = startPosition;
        var char = charSequenceGet(source, currentPosition);
        var usedAppend = false;
        while (!(char === _Char___init__impl__6a9atx(34))) {
          if (char === _Char___init__impl__6a9atx(92)) {
            usedAppend = true;
            currentPosition = this.l2x(appendEscape(this, lastPosition, currentPosition));
            if (currentPosition === -1) {
              this.o2s('Unexpected EOF', currentPosition);
            }
            lastPosition = currentPosition;
          } else {
            currentPosition = currentPosition + 1 | 0;
            if (currentPosition >= charSequenceLength(source)) {
              usedAppend = true;
              this.j2x(lastPosition, currentPosition);
              currentPosition = this.l2x(currentPosition);
              if (currentPosition === -1) {
                this.o2s('Unexpected EOF', currentPosition);
              }
              lastPosition = currentPosition;
            }
          }
          char = charSequenceGet(source, currentPosition);
        }
        var tmp;
        if (!usedAppend) {
          tmp = this.r2x(lastPosition, currentPosition);
        } else {
          tmp = decodedString(this, lastPosition, currentPosition);
        }
        var string = tmp;
        this.y2m_1 = currentPosition + 1 | 0;
        return string;
      }
      n2u() {
        var result = this.x2t();
        if (result === 'null' && wasUnquotedString(this)) {
          this.o2s("Unexpected 'null' value instead of string literal");
        }
        return result;
      }
      x2t() {
        if (!(this.a2n_1 == null)) {
          return takePeeked(this);
        }
        var current = this.n2x();
        if (current >= charSequenceLength(this.k2x()) || current === -1) {
          this.o2s('EOF', current);
        }
        var token = charToTokenClass(charSequenceGet(this.k2x(), current));
        if (token === 1) {
          return this.w2t();
        }
        if (!(token === 0)) {
          this.o2s('Expected beginning of the string, but got ' + toString(charSequenceGet(this.k2x(), current)));
        }
        var usedAppend = false;
        while (charToTokenClass(charSequenceGet(this.k2x(), current)) === 0) {
          current = current + 1 | 0;
          if (current >= charSequenceLength(this.k2x())) {
            usedAppend = true;
            this.j2x(this.y2m_1, current);
            var eof = this.l2x(current);
            if (eof === -1) {
              this.y2m_1 = current;
              return decodedString(this, 0, 0);
            } else {
              current = eof;
            }
          }
        }
        var tmp;
        if (!usedAppend) {
          tmp = this.r2x(this.y2m_1, current);
        } else {
          tmp = decodedString(this, this.y2m_1, current);
        }
        var result = tmp;
        this.y2m_1 = current;
        return result;
      }
      j2x(fromIndex, toIndex) {
        this.b2n_1.og(this.k2x(), fromIndex, toIndex);
      }
      l2u(allowLenientStrings) {
        // Inline function 'kotlin.collections.mutableListOf' call
        var tokenStack = ArrayList().p2();
        var lastToken = this.u2t();
        if (!(lastToken === 8) && !(lastToken === 6)) {
          this.x2t();
          return Unit_instance;
        }
        $l$loop: while (true) {
          lastToken = this.u2t();
          if (lastToken === 1) {
            if (allowLenientStrings)
              this.x2t();
            else
              this.m2u();
            continue $l$loop;
          }
          var tmp0_subject = lastToken;
          if (tmp0_subject === 8 || tmp0_subject === 6) {
            tokenStack.i2(lastToken);
          } else if (tmp0_subject === 9) {
            if (!(last(tokenStack) === 8)) {
              this.o2s('found ] instead of }');
            }
            removeLast(tokenStack);
          } else if (tmp0_subject === 7) {
            if (!(last(tokenStack) === 6)) {
              this.o2s('found } instead of ]');
            }
            removeLast(tokenStack);
          } else if (tmp0_subject === 10) {
            this.o2s('Unexpected end of input due to malformed JSON during ignoring unknown keys');
          }
          this.z2t();
          if (tokenStack.q2() === 0)
            return Unit_instance;
        }
      }
      toString() {
        return "JsonReader(source='" + toString_0(this.k2x()) + "', currentPosition=" + this.y2m_1 + ')';
      }
      k2u(key) {
        var processed = this.r2x(0, this.y2m_1);
        var lastIndexOf_0 = lastIndexOf(processed, key);
        this.n2s("Encountered an unknown key '" + key + "'", lastIndexOf_0, "Use 'ignoreUnknownKeys = true' in 'Json {}' builder or '@JsonIgnoreUnknownKeys' annotation to ignore unknown keys.");
      }
      n2s(message, position, hint) {
        throw decodingExceptionOf(this, message, position, this.z2m_1.c2t(), hint, this.k2x());
      }
      o2s(message, position, hint, $super) {
        position = position === VOID ? this.y2m_1 : position;
        hint = hint === VOID ? null : hint;
        return $super === VOID ? this.n2s(message, position, hint) : $super.n2s.call(this, message, position, hint);
      }
      v2u() {
        var current = this.n2x();
        current = this.l2x(current);
        if (current >= charSequenceLength(this.k2x()) || current === -1) {
          this.o2s('EOF');
        }
        var tmp;
        if (charSequenceGet(this.k2x(), current) === _Char___init__impl__6a9atx(34)) {
          current = current + 1 | 0;
          if (current === charSequenceLength(this.k2x())) {
            this.o2s('EOF');
          }
          tmp = true;
        } else {
          tmp = false;
        }
        var hasQuotation = tmp;
        var accumulator = 0n;
        var exponentAccumulator = 0n;
        var isNegative = false;
        var isExponentPositive = false;
        var hasExponent = false;
        var start = current;
        $l$loop_4: while (!(current === charSequenceLength(this.k2x()))) {
          var ch = charSequenceGet(this.k2x(), current);
          if ((ch === _Char___init__impl__6a9atx(101) || ch === _Char___init__impl__6a9atx(69)) && !hasExponent) {
            if (current === start) {
              this.o2s("Unexpected symbol '" + toString(ch) + "' in numeric literal", current);
            }
            isExponentPositive = true;
            hasExponent = true;
            current = current + 1 | 0;
            continue $l$loop_4;
          }
          if (ch === _Char___init__impl__6a9atx(45) && hasExponent) {
            if (current === start) {
              this.o2s("Unexpected symbol '-' in numeric literal", current);
            }
            isExponentPositive = false;
            current = current + 1 | 0;
            continue $l$loop_4;
          }
          if (ch === _Char___init__impl__6a9atx(43) && hasExponent) {
            if (current === start) {
              this.o2s("Unexpected symbol '+' in numeric literal", current);
            }
            isExponentPositive = true;
            current = current + 1 | 0;
            continue $l$loop_4;
          }
          if (ch === _Char___init__impl__6a9atx(45)) {
            if (!(current === start)) {
              this.o2s("Unexpected symbol '-' in numeric literal", current);
            }
            isNegative = true;
            current = current + 1 | 0;
            continue $l$loop_4;
          }
          var token = charToTokenClass(ch);
          if (!(token === 0))
            break $l$loop_4;
          current = current + 1 | 0;
          var digit = Char__minus_impl_a2frrh(ch, _Char___init__impl__6a9atx(48));
          if (!(0 <= digit ? digit <= 9 : false)) {
            this.o2s("Unexpected symbol '" + toString(ch) + "' in numeric literal", current - 1 | 0);
          }
          if (hasExponent) {
            // Inline function 'kotlin.Long.times' call
            var this_0 = exponentAccumulator;
            // Inline function 'kotlin.Long.plus' call
            var this_1 = multiply(this_0, fromInt(10));
            exponentAccumulator = add(this_1, fromInt(digit));
            continue $l$loop_4;
          }
          // Inline function 'kotlin.Long.times' call
          var this_2 = accumulator;
          // Inline function 'kotlin.Long.minus' call
          var this_3 = multiply(this_2, fromInt(10));
          accumulator = subtract(this_3, fromInt(digit));
          if (accumulator > 0n) {
            this.o2s('Numeric value overflow');
          }
        }
        var hasChars = !(current === start);
        if (start === current || (isNegative && start === (current - 1 | 0))) {
          this.o2s('Expected numeric literal', current);
        }
        if (hasQuotation) {
          if (!hasChars) {
            this.o2s('EOF');
          }
          if (!(charSequenceGet(this.k2x(), current) === _Char___init__impl__6a9atx(34))) {
            this.o2s('Expected closing quotation mark', current);
          }
          current = current + 1 | 0;
        }
        this.y2m_1 = current;
        if (hasExponent) {
          var doubleAccumulator = toNumber(accumulator) * consumeNumericLiteral$calculateExponent(exponentAccumulator, isExponentPositive);
          if (doubleAccumulator > toNumber(9223372036854775807n) || doubleAccumulator < toNumber(-9223372036854775808n)) {
            this.o2s('Numeric value overflow');
          }
          // Inline function 'kotlin.math.floor' call
          if (!(Math.floor(doubleAccumulator) === doubleAccumulator)) {
            this.o2s("Can't convert " + doubleAccumulator + ' to Long');
          }
          accumulator = numberToLong(doubleAccumulator);
        }
        var tmp_0;
        if (isNegative) {
          tmp_0 = accumulator;
        } else if (!(accumulator === -9223372036854775808n)) {
          tmp_0 = negate(accumulator);
        } else {
          this.o2s('Numeric value overflow');
        }
        return tmp_0;
      }
      d2p() {
        var result = this.v2u();
        var next = this.z2t();
        if (!(next === 10)) {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.fail' call
          var expected = tokenDescription(10);
          var position = true && this.y2m_1 > 0 ? this.y2m_1 - 1 | 0 : this.y2m_1;
          var s = this.y2m_1 === charSequenceLength(this.k2x()) || position < 0 ? 'EOF' : toString(charSequenceGet(this.k2x(), position));
          var tmp$ret$1 = "Expected input to contain a single valid number, but got '" + s + "' after it";
          this.o2s(tmp$ret$1, position);
        }
        return result;
      }
      u2u() {
        var current = this.n2x();
        if (current === charSequenceLength(this.k2x())) {
          this.o2s('EOF');
        }
        var tmp;
        if (charSequenceGet(this.k2x(), current) === _Char___init__impl__6a9atx(34)) {
          current = current + 1 | 0;
          tmp = true;
        } else {
          tmp = false;
        }
        var hasQuotation = tmp;
        var result = consumeBoolean2(this, current);
        if (hasQuotation) {
          if (this.y2m_1 === charSequenceLength(this.k2x())) {
            this.o2s('EOF');
          }
          if (!(charSequenceGet(this.k2x(), this.y2m_1) === _Char___init__impl__6a9atx(34))) {
            this.o2s('Expected closing quotation mark');
          }
          this.y2m_1 = this.y2m_1 + 1 | 0;
        }
        return result;
      }
    }
    initMetadataForClass($, 'AbstractJsonLexer');
    AbstractJsonLexerClass = $;
  }
  return AbstractJsonLexerClass;
}
function tokenDescription(token) {
  return token === 1 ? "quotation mark '\"'" : token === 2 ? "string escape sequence '\\'" : token === 4 ? "comma ','" : token === 5 ? "colon ':'" : token === 6 ? "start of the object '{'" : token === 7 ? "end of the object '}'" : token === 8 ? "start of the array '['" : token === 9 ? "end of the array ']'" : token === 10 ? 'end of the input' : token === 127 ? 'invalid token' : 'valid token';
}
function charToTokenClass(c) {
  var tmp;
  // Inline function 'kotlin.code' call
  if (Char__toInt_impl_vasixd(c) < 126) {
    var tmp_0 = CharMappings_getInstance().t2x_1;
    // Inline function 'kotlin.code' call
    tmp = tmp_0[Char__toInt_impl_vasixd(c)];
  } else {
    tmp = 0;
  }
  return tmp;
}
function escapeToChar(c) {
  return c < 117 ? CharMappings_getInstance().s2x_1[c] : _Char___init__impl__6a9atx(0);
}
function initEscape($this) {
  var inductionVariable = 0;
  if (inductionVariable <= 31)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      initC2ESC($this, i, _Char___init__impl__6a9atx(117));
    }
     while (inductionVariable <= 31);
  initC2ESC($this, 8, _Char___init__impl__6a9atx(98));
  initC2ESC($this, 9, _Char___init__impl__6a9atx(116));
  initC2ESC($this, 10, _Char___init__impl__6a9atx(110));
  initC2ESC($this, 12, _Char___init__impl__6a9atx(102));
  initC2ESC($this, 13, _Char___init__impl__6a9atx(114));
  initC2ESC_0($this, _Char___init__impl__6a9atx(47), _Char___init__impl__6a9atx(47));
  initC2ESC_0($this, _Char___init__impl__6a9atx(34), _Char___init__impl__6a9atx(34));
  initC2ESC_0($this, _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(92));
}
function initCharToToken($this) {
  var inductionVariable = 0;
  if (inductionVariable <= 32)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      initC2TC($this, i, 127);
    }
     while (inductionVariable <= 32);
  initC2TC($this, 9, 3);
  initC2TC($this, 10, 3);
  initC2TC($this, 13, 3);
  initC2TC($this, 32, 3);
  initC2TC_0($this, _Char___init__impl__6a9atx(44), 4);
  initC2TC_0($this, _Char___init__impl__6a9atx(58), 5);
  initC2TC_0($this, _Char___init__impl__6a9atx(123), 6);
  initC2TC_0($this, _Char___init__impl__6a9atx(125), 7);
  initC2TC_0($this, _Char___init__impl__6a9atx(91), 8);
  initC2TC_0($this, _Char___init__impl__6a9atx(93), 9);
  initC2TC_0($this, _Char___init__impl__6a9atx(34), 1);
  initC2TC_0($this, _Char___init__impl__6a9atx(92), 2);
}
function initC2ESC($this, c, esc) {
  if (!(esc === _Char___init__impl__6a9atx(117))) {
    // Inline function 'kotlin.code' call
    var tmp$ret$0 = Char__toInt_impl_vasixd(esc);
    $this.s2x_1[tmp$ret$0] = numberToChar(c);
  }
}
function initC2ESC_0($this, c, esc) {
  // Inline function 'kotlin.code' call
  var tmp$ret$0 = Char__toInt_impl_vasixd(c);
  return initC2ESC($this, tmp$ret$0, esc);
}
function initC2TC($this, c, cl) {
  $this.t2x_1[c] = cl;
}
function initC2TC_0($this, c, cl) {
  // Inline function 'kotlin.code' call
  var tmp$ret$0 = Char__toInt_impl_vasixd(c);
  return initC2TC($this, tmp$ret$0, cl);
}
var CharMappingsClass;
function CharMappings() {
  if (CharMappingsClass === VOID) {
    class $ {
      constructor() {
        CharMappings_instance = this;
        this.s2x_1 = charArray(117);
        this.t2x_1 = new Int8Array(126);
        initEscape(this);
        initCharToToken(this);
      }
    }
    initMetadataForObject($, 'CharMappings');
    CharMappingsClass = $;
  }
  return CharMappingsClass;
}
var CharMappings_instance;
function CharMappings_getInstance() {
  if (CharMappings_instance === VOID)
    new (CharMappings())();
  return CharMappings_instance;
}
//region block: exports
export {
  AbstractJsonLexer as AbstractJsonLexer1em5xl1wqsdtw,
  charToTokenClass as charToTokenClass1wja4xge82waq,
  tokenDescription as tokenDescription3r6eqmtoxe76u,
};
//endregion

//# sourceMappingURL=AbstractJsonLexer.mjs.map
